<template>
    <ModalComponent
        :name="'edit-voucher-' + voucher_id"
        title="Editar cupón"
    >
        <ContentOrLoading>
            <Form
                v-if="voucher"
                :voucher="voucher"
                @terminado="editarVoucher()"
            />
        </ContentOrLoading>        
    </ModalComponent>  
</template>

<script>
    import ModalComponent from '@/components/backend/components/ModalComponent.vue';
    import Form from '../Form.vue';

    export default {
        props: {
            voucher_id: {
                type: Number,
                required: true
            },
            show: {
                type: String,
                requried: true
            }
        },
        data() {
            return {
                voucher: null
            }
        },
        watch: {
            show() {
                if(this.show == 'edit-voucher-' + this.voucher_id) {
                    this.getVoucher()
                }
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaId;
            }
        },
        methods: {
            getVoucher() {
                let params = {
                    filters: {},
                    voucher_id: this.voucher_id,
                    lista_id: this.lista
                }

                this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.show'), params).then(res => {
                    this.voucher = res.data.data;

                    if(this.voucher.sin_vincular ) {
                        this.voucher.sin_vincular = true;
                    }
                });        
            },
            editarVoucher() {
                this.loading = true;
                this.voucher.filters = {};
                this.voucher.voucher_id = this.voucher_id,

                this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.edit'), this.voucher).then(res => {
                    this.cerrar();
                    this.$emit('actualizar');
                    this.loading = false;
                });            
            },
            cerrar() {
                this.$modal.hide('edit-voucher-' + this.voucher_id)
            }
        },
        components: {
            ModalComponent, Form
        }
    }
</script>
